export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14836.ec219207.jpg";